import { GET_ROLES, GET_USERS } from '../actions/action_types';
import { console_log } from "../utils/helper";

const initialState = {
    roles: [],
    users: []
};

export const UsersReducer = (state = initialState, action = {}) => {
    switch (action.type) {
        case GET_ROLES:
            return {
                ...state,
                roles: action.data.data
            };
        case GET_USERS:
            return {
                ...state,
                users: action.data.data
            };
        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/reducers/UsersReducer.js